// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-box {
  background-color: var(--background-consistent);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
}

.warning-text {
  color: var(--text-consistent);
  font-size: 1rem;
  margin: 8px 0;
}

.warning-list {
  color: var(--text-consistent);
  font-size: 1rem;
  padding-left: 24px;
  margin: 12px 0;
}

.btn-warning {
  background-color: #ff9800 !important;
  color: white;
}

.confirm-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.success-message {
  background-color: #4CAF50;
  color: white !important;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
  text-align: center;
  font-weight: bold;
  animation: fadeIn 0.3s, fadeOut 0.3s 2.7s;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
}

.error-message {
  background-color: #FF3A31;
  color: white;
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
  text-align: center;
  font-weight: bold;
  animation: fadeIn 0.3s, fadeOut 0.3s 2.7s;
  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;
}

.btn-cancel {
  background-color: var(--theme-consistent) !important;
}

.btn-confirm-warning {
  background-color: #FF3A31 !important;
  color: white;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes fadeOut {
  from { opacity: 1; transform: translateY(0); }
  to { opacity: 0; transform: translateY(-10px); }
}
`, "",{"version":3,"sources":["webpack://./src/assets/ResetLikeDislike.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,KAAK,UAAU,EAAE,4BAA4B,EAAE;AACjD","sourcesContent":[".warning-box {\n  background-color: var(--background-consistent);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 16px;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n}\n\n.warning-text {\n  color: var(--text-consistent);\n  font-size: 1rem;\n  margin: 8px 0;\n}\n\n.warning-list {\n  color: var(--text-consistent);\n  font-size: 1rem;\n  padding-left: 24px;\n  margin: 12px 0;\n}\n\n.btn-warning {\n  background-color: #ff9800 !important;\n  color: white;\n}\n\n.confirm-buttons {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.success-message {\n  background-color: #4CAF50;\n  color: white !important;\n  padding: 16px;\n  border-radius: 8px;\n  margin: 16px 0;\n  text-align: center;\n  font-weight: bold;\n  animation: fadeIn 0.3s, fadeOut 0.3s 2.7s;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n}\n\n.error-message {\n  background-color: #FF3A31;\n  color: white;\n  padding: 16px;\n  border-radius: 8px;\n  margin: 16px 0;\n  text-align: center;\n  font-weight: bold;\n  animation: fadeIn 0.3s, fadeOut 0.3s 2.7s;\n  box-shadow: rgb(40 40 40 / 35%) 0px 5px 15px;\n}\n\n.btn-cancel {\n  background-color: var(--theme-consistent) !important;\n}\n\n.btn-confirm-warning {\n  background-color: #FF3A31 !important;\n  color: white;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes fadeOut {\n  from { opacity: 1; transform: translateY(0); }\n  to { opacity: 0; transform: translateY(-10px); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
